// services/apiSlice.js or wherever your API slice is defined
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const slotPriceApi = createApi({
  reducerPath: 'slotPriceApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createSlotPricing: builder.mutation({
      query: ({duration, price}) => ({
        url: `/WebSlot/CreateSlotPricing`,
        method: "Post",
        params: { duration, price },
      }),
    }),
    getAllSlotPricing: builder.query({
      query: () => ({
        url: `/WebSlot/GetAllSlotPricing`,
        method: "Get",
        //params: {PageNumber, Take}
      }),
    }),
    updateSlotPricing: builder.mutation({
      query: (slotData) => ({
        url: '/WebSlot/UpdateSlotPricing',
        method: 'POST',
        body: slotData,
      }),
      invalidatesTags: ['SlotPricing'],
    }),
    deleteSlotPricing: builder.mutation({
      query: ({Id}) => ({
        url: `/WebSlot/DeleteSlotPricing`,
        method: "Post",
        params: { Id },
      }),
    }),
    adminRescheduleSession: builder.mutation({
      query: (credentials) => ({
        url: `/WebAdmin/RescheduleSlotSession`,
        method: "Post",
        body: credentials
      }),
    }),
    adminCancelSession: builder.mutation({
      query: ({sessionBookingId}) => ({
        url: `/WebAdmin/CancelSlotSession`,
        method: "Post",
        params: {sessionBookingId}
      }),
    }),
  }),
});

export const { 
  useCreateSlotPricingMutation,
  useGetAllSlotPricingQuery,
  useDeleteSlotPricingMutation,
  useUpdateSlotPricingMutation,
  useAdminRescheduleSessionMutation,
  useAdminCancelSessionMutation
} = slotPriceApi;